import ConfirmDeviceDeletionDialog from './ConfirmDeviceDeletionDialog';

export default ConfirmDeviceDeletionDialog;
